import { Spinner, BlockStack, Text } from '@shopify/polaris';

export interface LoadingStateProps {
  message?: string;
}

export function LoadingState({ message }: LoadingStateProps): JSX.Element {
  return (
    <BlockStack inlineAlign="center" gap="200">
      <Spinner accessibilityLabel="Loading" size="large" />
      {message ? <Text as="p" variant="bodyMd">{message}</Text> : null}
    </BlockStack>
  );
}
